export const PASSWORD_LENGTH = 8;

export const getRandomIntFactory = (min, max) => () => {
  // NOTE:
  //  crypto.getRandomValuesとUint32Arrayを用いて 0 ~ (2**32 -1)の範囲の整数を作成
  //  2**32(4294967296) で割って 0以上1未満 の少数を作成
  return Math.floor(
    (crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296) *
      (max - min + 1) +
      min,
  );
};

export const generatePassword = (length = PASSWORD_LENGTH) => {
  const min = "!".charCodeAt(0);
  const max = "~".charCodeAt(0);
  const getRandInt = getRandomIntFactory(min, max);
  return [...new Array(length).keys()]
    .map(() => String.fromCharCode(getRandInt()))
    .join("");
};
